import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=60352b94&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=60352b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60352b94",
  null
  
)

export default component.exports